module.exports = "https://99designs-start-assets.imgix.net/js/2ffec2675d2bf8f4f0d49f11e0eae1b3.png";